export const GET_PROGRAM_INSTRUMENTS = "GET_PROGRAM_INSTRUMENTS";
export const GET_PROGRAM_INSTRUMENT_BY_ID = "GET_PROGRAM_INSTRUMENT_BY_ID";
export const UPDATE_PROGRAM_INSTRUMENT = "UPDATE_PROGRAM_INSTRUMENT";
export const DELETE_PROGRAM_INSTRUMENT = "DELETE_PROGRAM_INSTRUMENT";
export const CREATE_PROGRAM_INSTRUMENT = "CREATE_PROGRAM_INSTRUMENT";
